import EventPageTemplate from "../components/EventPageTemplate";
import { IMG } from "../data/site";
import useSEO from "../hooks/useSEO";

export default function EventiAziendali() {
  useSEO(
    "Eventi aziendali: beverage per inaugurazioni e meeting | Sprizziamoci",
    "Sprizziamoci per inaugurazioni, presentazioni, meeting informali, ricorrenze e feste aziendali: servizio beverage professionale, ordinato e personalizzabile."
  );
  return (
    <EventPageTemplate
      eyebrow="Eventi aziendali"
      titleLines={["Il networking incontra", "l'aperitivo."]}
      intro="Inaugurazioni, presentazioni, meeting e feste aziendali: un servizio ordinato, professionale, personalizzabile."
      image={IMG.corpNet}
      imageAlt="Ospiti in conversazione durante un ricevimento aziendale"
      occasions={[
        "Inaugurazioni e opening",
        "Presentazioni e meeting informali",
        "Ricorrenze e feste aziendali",
        "Convention e reception",
        "Team building e momenti di aggregazione",
      ]}
      paragraphs={[
        "Servizio in autonomia: gli ospiti si servono da soli, senza attese. Formula e bevande definite nella proposta.",
      ]}
      cta="Richiedi una proposta aziendale"
      selfNote={false}
      preventivoCta
    />
  );
}
